import { SbBlokData, storyblokEditable } from "@storyblok/js";

import { marked } from "marked";

import type { MediaCardStoryblok } from "@/types/blok-types";

import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import clsx from "clsx";
import SomeIcon from "./SomeIcon";
import styles from "./media-card.module.css";

const MediaCard = ({
  blok,
  sizes = "100vw",
  preview
}: {
  blok: MediaCardStoryblok;
  sizes: string;
  preview: boolean;
}) => {
  const mediaBlok = blok?.media?.[0];

  const MainImage = () =>
    !mediaBlok ? null : (
      <div className={clsx(styles.image, "media-card--image")}>
        <StoryblokComponent sizes={sizes} blok={mediaBlok} preview={preview} />
      </div>
    );

  // text under image
  const AltText = () =>
    !blok?.imageText ? null : (
      <div
        dangerouslySetInnerHTML={{
          __html: marked.parse(blok?.imageText || "")
        }}
      />
    );

  const SocialTag = () =>
    !blok.socialTag ? null : (
      <div className={styles.socialIcon}>
        <SomeIcon socialIcon={blok.socialIcon} /> {blok?.socialTag}
      </div>
    );

  return (
    <>
      <div
        className={clsx(styles.root, "media-card")}
        {...storyblokEditable(blok as unknown as SbBlokData)}
      >
        <MainImage />
        <AltText />
        <SocialTag />
      </div>
    </>
  );
};

export default MediaCard;
